import { useState, useCallback } from 'react'
import { getTranscriptIndex, searchTranscripts } from '../lib/transcript-store'
import type { TranscriptChunk } from '../lib/types'

export function useTranscripts() {
  const [results, setResults] = useState<{ chunk: TranscriptChunk; score: number }[]>([])
  const [loading, setLoading] = useState(false)
  const [totalChunks, setTotalChunks] = useState(0)
  const [totalDocs, setTotalDocs] = useState(0)

  const init = useCallback(async () => {
    try {
      const index = await getTranscriptIndex()
      setTotalChunks(index.totalChunks)
      setTotalDocs(index.totalDocuments)
    } catch {
      // silently fail
    }
  }, [])

  const search = useCallback(async (query: string) => {
    if (!query.trim()) {
      setResults([])
      return
    }
    setLoading(true)
    try {
      const res = await searchTranscripts(query)
      setResults(res)
    } catch {
      setResults([])
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    results,
    loading,
    totalChunks,
    totalDocs,
    search,
    init,
  }
}
